import React from 'react';

const Tab = (props) => {
    const { className, tabData, isActive, onTabSelectHandler, idx, onKeyDown } = props;

    return (
        <div className={`grid-col-6 gi-tabs__item ${className}`}>
            <button className={isActive ? 'active' : ''}
                id={`tab-${idx}`}
                role="tab"
                tabIndex={isActive ? 0 : -1}
                onClick={onTabSelectHandler}
                onKeyDown={onKeyDown}
                data-automation-id={`tab-${tabData.applicationYear}`}
                aria-selected={isActive ? 'true' : 'false'}
                aria-controls={`tabpanel_${tabData.applicationYear}`}>
                {tabData.applicationYear}
            </button>
        </div>
    );
};

export default Tab;